import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

export const DEFAULT_CONTENT = {
  hero: {
    pt: {
      overline: "Advocacia de Família · Funchal, Madeira",
      titleLines: ["Direito da Família", "com discrição,", "rigor e humanidade."],
      subtitle: "Acompanhamento jurídico próximo em divórcio, responsabilidades parentais e nas várias dimensões da vida familiar — presencialmente no Funchal ou onde estiver no mundo.",
    },
    en: {
      overline: "Family Law · Funchal, Madeira",
      titleLines: ["Family law", "with discretion,", "rigour and humanity."],
      subtitle: "Close legal counsel in divorce, parental responsibilities and the many dimensions of family life — in person in Funchal or wherever you are in the world.",
    },
  },
  practiceAreas: [
    { id: "divorcio", num: "01", route: null,
      pt: { title: "Divórcio e Separação", desc: "Acompanhamento sereno e rigoroso em processos de divórcio e separação, por mútuo acordo ou litigiosos, e em tudo o que deles decorre." },
      en: { title: "Divorce & Separation", desc: "Calm, rigorous support through divorce and separation — by agreement or contested — and everything that follows." } },
    { id: "consulta", num: "02", route: "consulta",
      pt: { title: "Responsabilidades Parentais", desc: "A proteção do bem-estar das crianças: guarda, residência, convívios e o dia a dia dos filhos após a separação." },
      en: { title: "Parental Responsibilities", desc: "Protecting children's well-being: custody, residence, contact and daily life after a separation." } },
    { id: "alimentos", num: "03", route: null,
      pt: { title: "Pensões de Alimentos", desc: "Soluções justas e sustentáveis na definição, revisão e cumprimento das pensões de alimentos." },
      en: { title: "Child & Spousal Support", desc: "Fair, sustainable solutions for setting, reviewing and enforcing maintenance." } },
    { id: "internacional", num: "04", route: "internacional",
      pt: { title: "Direito da Família Internacional", desc: "Apoio a famílias com ligações a mais do que um país, quando o divórcio ou as questões dos filhos atravessam fronteiras." },
      en: { title: "International Family Law", desc: "Support for families with ties to more than one country, when divorce or children's matters cross borders." } },
    { id: "patrimonio", num: "05", route: null,
      pt: { title: "União de Facto e Património", desc: "Reconhecimento da união de facto e organização do património do casal, com clareza e segurança jurídica." },
      en: { title: "Cohabitation & Assets", desc: "Recognition of cohabitation and organising the couple's assets, with clarity and legal certainty." } },
    { id: "vistos", num: "06", route: "vistos",
      pt: { title: "Vistos e Residência", desc: "Acompanhamento a quem escolhe viver em Portugal e na Madeira, com especial atenção ao reagrupamento da família." },
      en: { title: "Visas & Residency", desc: "Guidance for those choosing to live in Portugal and Madeira, with special care for family reunification." } },
  ],
  guide: {
    pt: { title: "Guia das Responsabilidades Parentais", desc: "Um guia claro e gratuito sobre direitos e deveres dos pais após a separação. Receba-o por email." },
    en: { title: "Guide to Parental Responsibilities", desc: "A clear, free guide to parents' rights and duties after separation. Receive it by email." },
  },
};

const ContentCtx = createContext(null);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  useEffect(() => {
    api.get("/content").then((r) => { if (r.data) setContent(r.data); }).catch(() => {});
  }, []);
  const value = useMemo(() => ({ content, setContent }), [content]);
  return <ContentCtx.Provider value={value}>{children}</ContentCtx.Provider>;
};

export const useContent = () => useContext(ContentCtx);
